import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Sparkles, ExternalLink, Mail } from "lucide-react";
import { getRiskBadge } from "./helpers";

export const RecommendedSection = ({ opps, t }) => {
  if (!opps || opps.length === 0) return null;
  return (
    <Card className="border-primary/30 bg-primary/[0.02]" data-testid="recommended-section">
      <CardHeader className="pb-2">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-primary" />
          <CardTitle className="text-xs font-bold tracking-widest uppercase text-primary">{t("opps.recommended")}</CardTitle>
          <Badge className="bg-primary/10 text-primary border-primary/20 hover:bg-primary/10 text-[10px]">{opps.length}</Badge>
        </div>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
          {opps.map((opp, i) => (
            <div key={opp.opp_id || i} className="p-3 bg-background rounded-lg border border-primary/10 hover:border-primary/30 transition-colors" data-testid={`recommended-card-${i}`}>
              <div className="flex items-start justify-between mb-2">
                <div className="min-w-0 flex-1">
                  <p className="font-bold text-sm truncate">{opp.name}</p>
                  {opp.description && <p className="text-[11px] text-muted-foreground truncate">{opp.description}</p>}
                </div>
                {getRiskBadge(opp.risk_score)}
              </div>
              <div className="flex flex-wrap gap-1.5 mb-2">
                {opp.custom_type && <Badge variant="outline" className="text-[9px]">{opp.custom_type}</Badge>}
                <Badge variant="outline" className="text-[9px] font-mono">{opp.currency || "USD"}</Badge>
                {opp.category && <Badge variant="outline" className="text-[9px]">{opp.category}</Badge>}
              </div>
              <div className="flex items-center gap-3 text-[11px] text-muted-foreground mb-2">
                {opp.expected_return && <span className="text-green-500 font-mono font-bold">{opp.expected_return}</span>}
                {opp.ticket && <span>Min: {opp.ticket}</span>}
                {opp.expiration_date && <span>Exp: {opp.expiration_date}</span>}
              </div>
              <div className="flex gap-2">
                {opp.url && (<Button variant="default" size="sm" className="text-xs flex-1 bg-primary text-primary-foreground" onClick={() => window.open(opp.url, "_blank")}><ExternalLink className="w-3 h-3 mr-1" /> View</Button>)}
                {opp.contact && (<Button variant="outline" size="sm" className="text-xs" onClick={() => window.open(opp.contact.includes("@") ? `mailto:${opp.contact}` : opp.contact, "_blank")}><Mail className="w-3 h-3 mr-1" /> Contact</Button>)}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
